<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>投标</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="$router.back(-1)">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>
        <el-form :model="bidDoc" ref="bidDoc" :rules="rules">
            <div class="bid-container">

                <div class="content-caption dashed bg-white">
                    <span>招标信息</span>
                </div>

                <div class="clearfix">

                    <div class="form-single col-2">
                        <div class="title">招标标题</div>
                        <div class="content">
                            <label class="mr20">{{callBidDocInfo.title}}</label>
                        </div>
                    </div>
                    <div class="form-single col-2">
                        <div class="title">报名时间</div>
                        <div class="content">
                            <label class="mr20">{{callBidDocInfo.publishTime}}</label>
                        </div>
                    </div>
                    <div class="form-single col-2">
                        <div class="title">报名截止时间</div>
                        <div class="content">
                            <label class="mr20">{{callBidDocInfo.openTime}}</label>
                        </div>
                    </div>
                    <div class="form-single col-2">
                        <div class="title">投标时间</div>
                        <div class="content">
                            <label class="mr20">{{callBidDocInfo.openTime}}</label>
                        </div>
                    </div>
                    <div class="form-single col-2">
                        <div class="title">投标截止时间</div>
                        <div class="content">
                            <label class="mr20">{{callBidDocInfo.closeTime}}</label>
                        </div>
                    </div>
                    <div class="form-single col-2">
                        <div class="title">公布结果时间</div>
                        <div class="content">
                            <label class="mr20">{{callBidDocInfo.resultPublishTime}}</label>
                        </div>
                    </div>
                    <div class="form-single col-2">
                        <div class="title">招标预算</div>
                        <div class="content">
                            <label v-if="callBidDocInfo.budgetFlag == 0 " class="mr20">无预算</label>
                            <label v-if="callBidDocInfo.budgetFlag == 2 " class="mr20">固定总额 {{callBidDocInfo.budgetAmount}} 元</label>
                        </div>
                    </div>
                    <div class="form-single col-2">
                        <div class="title">要求注册资金</div>
                        <div class="content">
                            <label class="mr20">{{callBidDocInfo.reqRegCapital}} 万元</label>
                        </div>
                    </div>
                </div>

                <div class="clearfix">
                    <div class="content-caption dashed bg-white">
                        <span>投标信息</span>
                    </div>

                    <div class="form-single col-2" style="overflow: visible">
                        <div class="title required">投标报价</div>
                        <div class="content">
                            <el-form-item prop="offerPrice">
                                <el-input style="width: 160px" v-model.number="bidDoc.offerPrice" placeholder="请输入报价金额" type="number"></el-input>&nbsp;<span>(元)</span>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="form-single col-2" style="overflow: visible">
                        <div class="title required">联系人</div>
                        <div class="content">
                            <el-form-item prop="contactName">
                                <el-input class="width-1-5x" v-model="bidDoc.contactName" placeholder="请输入联系人"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="form-single col-2" style="overflow: visible">
                        <div class="title required">联系电话</div>
                        <div class="content">
                            <el-form-item prop="contactTel">
                                <el-input class="width-1-5x" v-model="bidDoc.contactTel" placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="form-single col-2">
                        <div class="title">邮箱</div>
                        <div class="content">
                            <el-form-item prop="contactEmail">
                                <el-input class="width-1-5x" placeholder="请输入邮箱" v-model="bidDoc.contactEmail"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white" v-if="bidGoodsList!=null && bidGoodsList.length>0">
                    <span>商品信息</span>
                </div>
                <div v-if="bidGoodsList!=null && bidGoodsList.length>0">
                    <table class="custom-tbl">
                        <thead class="head">
                        <tr class="row">
                            <th style="text-align: left;" width="200"><span class="ml5">招标产品</span></th>
                            <th width="80">招标数量</th>
                            <th width="80">招标单位</th>
                            <th style="text-align: left;"><span class="ml5">投标产品</span></th>
                            <th width="80">招标质保期(月)</th>
                            <th width="80">投标质保期(月)</th>
                            <th width="100">投标价格(元)</th>
                            <th width="60">操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row" v-for="bidGoods in bidGoodsList">
                            <td style="text-align: left"><span class="ml5">{{bidGoods.callName}}</span></td>
                            <td>{{bidGoods.callQuantity}}</td>
                            <td>{{bidGoods.callUnit}}</td>
                            <td style="text-align: left"><span class="ml5">{{bidGoods.name}}</span></td>
                            <td>{{bidGoods.callWrntPeriod}}</td>
                            <td>
                                <el-input v-model="bidGoods.wrntPeriod"></el-input>
                            </td>
                            <td>
                                <el-input v-model="bidGoods.price"></el-input>
                            </td>

                            <td><a class="swb-btn-link" @click="showMerchantGoodsDialog(bidGoods.callId)">选择</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="content-caption dashed bg-white mt30">
                    <span>服务信息</span>
                </div>
                <div v-if="bidServcList!=null && bidServcList.length>0">
                    <table class="custom-tbl">
                        <thead class="head">
                        <tr class="row">
                            <th style="text-align: left;" width="300"><span class="ml5">招标服务</span></th>
                            <th style="text-align: left;"><span class="ml5">投标服务</span></th>
                            <th width="100">投标价格</th>
                            <th width="60">操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row" v-for="bidServc in bidServcList">
                            <td style="text-align: left;" width="300"><span class="ml5">{{bidServc.callName}}</span></td>
                            <td style="text-align: left"><span class="ml5">{{bidServc.name}}</span></td>
                            <td>
                                <el-input v-model="bidServc.price"></el-input>
                            </td>
                            <td>
                                <a class="swb-btn-link" @click="showMerchantServcDialog(bidServc.callId)">选择</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>附件信息</span>
                </div>
                <div class="form-single mt20">
                    <div class="title required">上传附件</div>
                    <div class="content required" style="padding-left: 38px;">
                        <swb-file-upload :fileFor="'solution'" fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                        <div class="file-area clearfix">
                            <swb-file-item v-for="(bidFile, index) in bidFileList" :trackKey="index" :editable="true" :tag="bidFile.tag" :fileName="bidFile.name" :fileUuid="bidFile.fileUuid" :fileBrowseUrl="bidFile.fileBrowseUrl" :fileDownloadUrl="bidFile.fileDownloadUrl" :fileMd5="bidFile.fileMd5" :deletable="true" :onDelete="removeUpload" :onUploaded="echoUploadedFileInfo"></swb-file-item>
                        </div>
                    </div>
                </div>
                <div class="content-caption dashed bg-white">
                    <span>商务条款</span>
                </div>
                <swb-create-trade-rule v-if="bidTermParams.tradeRuleList != null" :comparedTradeRuleList="bidTermParams.tradeRuleList" :forBid=true :forGoods="bidTermParams.forGoods" :operate="bidTermParams.operate" :forServc="bidTermParams.forServc" :type="bidTermParams.type" :returnType="bidTermParams.returnType" ref="swb_create_trade_rule"></swb-create-trade-rule>

            </div>
        </el-form>
        <div class="form-toolbar align-center mt30" style="padding: 0;">
            <button class="swb-btn mr20" @click="saveBidDoc()">保存</button> <!-- true 是否保存 -->
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import callBidApi from '../../api/callBid'
    import tendBidApi from '../../api/tendBid'

    import SwbSkuListForSelect from '../goods/SkuListForSelect';
    Vue.regist(SwbSkuListForSelect);

    import SwbServcForSelect from '../servc/ServcForSelect';
    Vue.regist(SwbServcForSelect);

    import SwbMerchantQualiForSelect from '../quali/MerchantQualiForSelect';
    Vue.regist(SwbMerchantQualiForSelect);

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    Vue.regist(SwbCreateTradeRule);

    import SwbMsuListSelect from '../servc/MsuListSelect';
    Vue.regist(SwbMsuListSelect);

    import SwbBidDocList from './BidDocList';
    Routes.add(SwbBidDocList);

    export default {
        name: 'swb-save-bid-doc',
        path: '/tend/bid/doc/save',
        pathOld: '/bid/doc/save',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '投标书编辑（新增、修改）',

        data: function () {
            var checkRspDeposit = (rule, value, callback) => {
                setTimeout(() => {
                    if(!Number.isInteger(value)) {
                        callback(new Error('请输入数字值'));
                    } else {
                        if(value < 0) {
                            callback(new Error('请输入大于0的整数值'));
                        } else {
                            callback();
                        }
                    }
                }, 100);
            };

            var checkName = (rule, value, callback) => {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入联系人'));
                } else {
                    callback();
                }
            };

            var checkTel = (rule, value, callback) => {
                if(!Utils.isPhoneNo(value)) {
                    callback(new Error('请输入电话号码'));
                } else {
                    callback();
                }
            };
            var checkOfferPrice = (rule, value, callback) => {
                if(!Utils.isMoneyStr(value)) {
                    callback(new Error('请输入金额数据'));
                } else {
                    callback();
                }
            };
            return {
                //
                bidEnrollId: null,
                callBidDocId: null,
                callBidDocInfo: {},
                //
                bidDoc: {},
                //
                bidGoodsList: [],
                bidServcList: [],
                //
                bidQualiList: [],
                bidFileList: [],
                //
                bidTermParams: {
                    tradeRuleList: [],
                    type: 'callBid',
                    returnType: 'bid',
                    operate: null,
                    forGoods: true,
                    forServc: true
                },
                //
                rules: {
                    rspDeposit: [
                        {validator: checkRspDeposit, trigger: 'blur'}
                    ],
                    rspRegCapital: [
                        {validator: checkRspDeposit, trigger: 'blur'}
                    ],
                    contactTel: [
                        {validator: checkTel, trigger: 'blur'}
                    ],
                    contactName: [
                        {validator: checkName, trigger: 'blur'}
                    ],
                    offerPrice: [
                        {validator: checkOfferPrice, trigger: 'blur'}
                    ]
                }
            };

        },
        created: function () {
            let id = this.$route.query.id;
            if(id != null) {
                this.bidTermParams.type = 'bid';
                this.getBidDocInfo(id);
            } else {
                this.callBidDocId = this.$route.query.callBidDocId;
                this.bidEnrollId = this.$route.query.bidEnrollId;
                //
                this.getCallBidDocInfo();
                this.getCallBidTradeRuleInfo();
            }
        },
        methods: {
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let bidFiles = [];
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let file = files[i];
                        let bidFile = {};
                        bidFile.name = file.fileName;
                        bidFile.fileUuid = file.fileUuid;
                        bidFile.fileExtName = file.fileExtName;
                        bidFile.fileBrowseUrl = file.fileBrowseUrl;
                        bidFile.fileDownloadUrl = file.fileDownloadUrl;
                        bidFile.fileMd5 = file.fileMd5;
                        bidFile.tag = file.tag || Utils.genUniqueStr() + i;
                        bidFiles.push(bidFile);
                    }
                    let fileList = self.bidFileList.concat(bidFiles);
                    self.bidFileList = Utils.merge([], fileList);
                } else {
                    MsgBox.failure(result.message);
                }
            },

            downloadDemoFile: function (fileDownloadUrl) {
                Utils.downloadFile(getAppUrl(fileDownloadUrl));
            },

            removeUpload: function (index) {
                this.bidFileList.removeAt(index.trackKey);
                return false;
            },

            echoUploadedFileInfo: function (fileInfo) {
                //
                let fileMap = this.bidFileList.toMap("tag");
                fileMap = Utils.KeyMap.from(fileMap);
                //
                let file = fileMap.get(fileInfo.tag);
                file.name = fileInfo.fileName;
                file.fileUuid = fileInfo.fileUuid;
                file.fileExtName = fileInfo.fileExt;
                file.fileBrowseUrl = fileInfo.fileBrowseUrl;
                file.fileDownloaddUrl = fileInfo.fileDownloadUrl;
                file.fileMd5 = fileInfo.fileMd5;
                file.tag = fileInfo.tag || Utils.genUniqueStr() + i;
                //
                fileMap.set(file.tag, file);
                let files = fileMap.values();
                //
                this.bidFileList = Utils.merge([], files);
            },

            getCallBidDocInfo: function () {
                let self = this;
                //
                let theLoad = MsgBox.loading();
                callBidApi.getCallBidDocInfo(self.callBidDocId, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let callBidDocInfo = result.data;

                        self.bidDoc.callDocId = callBidDocInfo.id;

                        self.bidDoc.enrollId = self.bidEnrollId;

                        self.bidDoc.title = callBidDocInfo.title;

                        self.bidDoc.fstPartyId = callBidDocInfo.merchantId;
                        self.bidDoc.fstPartyType = callBidDocInfo.merchantType;
                        self.bidDoc.fstPartyName = callBidDocInfo.merchantName;

                        self.bidDoc.goodsFlag = callBidDocInfo.goodsFlag;
                        self.bidTermParams.forGoods = callBidDocInfo.goodsFlag;

                        self.bidDoc.servcFlag = callBidDocInfo.servcFlag;
                        self.bidTermParams.forServc = callBidDocInfo.servcFlag;

                        //转注册资金(为万元)
                        if(typeof callBidDocInfo.reqRegCapital == 'number') {
                            callBidDocInfo.reqRegCapital = (callBidDocInfo.reqRegCapital / 10000).round(4);
                        }

                        if(self.bidDoc.id == null) {
                            //组合结构
                            let callBidGoodsList = callBidDocInfo.callBidGoodsList || [];
                            let bidGoodsList = [];
                            for(var i = 0; i < callBidGoodsList.length; i++) {
                                let callBidGoods = callBidGoodsList[i];
                                let bidGoods = {};

                                bidGoods.callId = callBidGoods.id;
                                bidGoods.callDocId = callBidGoods.docId;
                                bidGoods.callName = callBidGoods.name;
                                bidGoods.callQuantity = callBidGoods.quantity;
                                bidGoods.callUnit = callBidGoods.unit;
                                bidGoods.callWrntPeriod = callBidGoods.wrntPeriod;
                                //初始化质保期
                                bidGoods.wrntPeriod = bidGoods.callWrntPeriod;

                                bidGoodsList.add(bidGoods);
                            }
                            self.bidGoodsList = bidGoodsList;

                            //
                            let callBidServcList = callBidDocInfo.callBidServcList || [];
                            let bidServcList = [];
                            for(var i = 0; i < callBidServcList.length; i++) {
                                let callBidServc = callBidServcList[i];
                                let bidServc = {};
                                bidServc.callId = callBidServc.id;
                                bidServc.callDocId = callBidServc.docId;
                                bidServc.callName = callBidServc.name;

                                bidServcList.add(bidServc);
                            }
                            self.bidServcList = bidServcList;
                        }

                        self.callBidDocInfo = callBidDocInfo;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });

            },

            //获取招标书交易规则
            getCallBidTradeRuleInfo: function () {
                let self = this;
                let postData = {};
                postData.docId = self.callBidDocId;
                callBidApi.getCallBidTermList(postData, function (result) {
                    if(result.type == 'info') {
                        let callBidTermList = result.data;
                        if(callBidTermList != null && callBidTermList.length > 0) {
                            self.bidTermParams.tradeRuleList = callBidTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                    }
                });
            },

            getBidDocInfo: function (id) {
                let self = this;
                let theLoad = MsgBox.loading();
                tendBidApi.getBidDocInfo(id, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let bidDoc = result.data;
                        //
                        self.bidGoodsList = bidDoc.bidGoodsList || [];
                        delete bidDoc['bidGoodsList'];

                        self.bidServcList = bidDoc.bidServcList || [];
                        delete bidDoc['bidServcList'];

                        self.bidQualiList = bidDoc.bidQualiList || [];
                        delete bidDoc['bidQualiList'];

                        let bidFileList = bidDoc.bidFileList || [];
                        for(let i = 0; i < bidFileList.length; i++) {
                            let bidFile = bidFileList[i];
                            bidFile.tag = bidFile.tag || Utils.genUniqueStr() + i
                        }
                        self.bidFileList = bidFileList;
                        delete bidDoc['bidFileList'];

                        self.bidDoc = bidDoc;
                        //
                        self.callBidDocId = bidDoc.callDocId;
                        self.getCallBidDocInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });

                self.getBidTradeRuleInfo(id);
            },
            //获取投标书交易规则
            getBidTradeRuleInfo: function (id) {
                let self = this;
                let postData = {};
                postData.docId = id;
                tendBidApi.getBidTermList(postData, function (result) {
                    if(result.type == 'info') {
                        let bidTermList = result.data;
                        if(bidTermList != null && bidTermList.length > 0) {
                            self.bidTermParams.tradeRuleList = bidTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                    }
                });
            },
            showMerchantGoodsDialog: function (callId) {
                let self = this;
                //
                Vue.$showDialog({
                    title: "选择商品",
                    showCloseBtn: true,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-sku-list-for-select :checkBox="false" :filter="filter" ref="swb_bid_goods_select"></swb-sku-list-for-select>' +
                    '</div>',
                    data: {
                        loading: false,
                        filter: {},
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_bid_goods_select.getDlgResult() || {};
                        if(result.type == 'info') {
                            let resultData = result.data;

                            let bidGoodsList = self.bidGoodsList;
                            let bidGoods = bidGoodsList.find(function (item) {
                                return item.callId == callId;
                            });

                            if(bidGoods == null) {
                                Toast.show('找不到对应的投标商品', 3000, 'warning');
                                return false;
                            }
                            bidGoods.name = resultData.title;
                            bidGoods.skuId = resultData.id;
                            bidGoods.goodsId = resultData.goodsId;
                            bidGoods.brandId = resultData.brandId;
                            bidGoods.brandName = resultData.brandName;
                            bidGoods.price = resultData.salePrice;
                            bidGoods.wrntPeriod = resultData.wrntPeriod || bidGoods.wrntPeriod;
                            //
                            self.bidGoodsList = Utils.merge([], bidGoodsList);
                            return true;
                        }
                        else {
                            Toast.show('请选择投标商品', 3000, 'warning');
                            return false;
                        }
                    },
                    methods: {},
                    lifecycle: {
                        created: function () {
                            this.filter.cccVerified = true;
                        }
                    }
                });
            },

            showMerchantServcDialog: function (callId) {
                let self = this;
                Vue.$showDialog({
                    title: "选择服务",
                    showCloseBtn: true,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-msu-list-select :checkBox="false" ref="swb_msu_list_select"></swb-msu-list-select>' +
                    '</div>',
                    data: {
                        loading: false,
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_msu_list_select.getDlgResult() || {};
                        if(result !== null) {
                            if(result.type == 'info') {
                                let resultData = result.data;

                                let bidServcList = self.bidServcList;

                                let bidServc = bidServcList.find(function (item) {
                                    return item.callId == callId;
                                });

                                if(bidServc == null) {
                                    Toast.show('找不到对应的投标服务', 3000, 'warning');
                                    return false;
                                }

                                bidServc.name = resultData.title;
                                bidServc.ssuId = resultData.id;
                                bidServc.servcId = resultData.servcId;
                                bidServc.price = resultData.generallFee;
                                //
                                self.bidServcList = Utils.merge([], bidServcList);
                                return true;
                            }
                        } else {
                            Toast.show('请选择投标服务', 3000, 'warning');
                            return false;
                        }
                    },
                    methods: {},
                });
            },

            saveBidDoc: function () {
                let self = this;
                let bidDoc = merge({}, self.bidDoc);
                self.$refs['bidDoc'].validate(function (valid) {
                    if(valid) {
                        if(!Utils.isNoB(bidDoc.contactEmail)) {
                            if(!Utils.isEmail(bidDoc.contactEmail)) {
                                Toast.show('邮箱格式不正确');
                                return false;
                            }
                        }
                        let bidGoodsList = self.bidGoodsList;
                        for(let i = 0; i < bidGoodsList.length; i++) {
                            let bidGoods = bidGoodsList[i];
                            if(bidGoods.goodsId == null) {
                                Toast.show(bidGoods.callName + ' 没有 指定 对应商品');
                                return false;
                            }
                        }
                        bidDoc.bidGoodsList = bidGoodsList;

                        let bidServcList = self.bidServcList;
                        for(let i = 0; i < bidServcList.length; i++) {
                            let bidServc = bidServcList[i];
                            if(bidServc.servcId == null) {
                                Toast.show(bidServc.callName + ' 没有 指定 对应服务');
                                return false;
                            }
                        }
                        bidDoc.bidServcList = bidServcList;

                        bidDoc.bidQualiList = self.bidQualiList;
                        let bidFileList = self.bidFileList;
                        if(bidFileList.length <= 0) {
                            Toast.show("请上传对应的招标文件");
                            return false;
                        } else {
                            bidDoc.bidFileList = self.bidFileList;
                        }

                        let resultRule = self.$refs.swb_create_trade_rule.getResult();
                        if(resultRule.type == 'info') {
                            bidDoc.bidTermList = resultRule.data || [];

                            let bidTermList = bidDoc.bidTermList;

                            if(self.bidTermParams.type == 'callBid') {
                                for(var i = 0; i < bidTermList.length; i++) {
                                    bidTermList[i].bidTermValueList = Utils.copyAsArray(bidTermList[i].callBidTermValueList);
                                }
                            } else {
                                for(var i = 0; i < bidTermList.length; i++) {
                                    bidTermList[i].bidTermValueList = Utils.copyAsArray(bidTermList[i].bidTermValueList);
                                }
                            }
                        } else {
                            Toast.warn(resultRule.message, 3000, 'warning');
                            return false;
                        }
                        //
                        let loading = MsgBox.loading();
                        tendBidApi.saveBidDoc(bidDoc, function (result) {
                            if(result.type == 'info') {
                                MsgBox.success("保存投标书成功");
                                self.toBidList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                            loading.hide();
                        });
                    }
                });
            },
            toBidList: function () {
                this.$router.push({
                    path: SwbBidDocList.path
                });
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/SaveBidDoc.vue